module.exports = __webpack_public_path__ + "static/media/professors.24064b50.png";